import * as React from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import {
    Button,
    Icons,
    Panel,
    PanelBody,
    CloseButton,
    PanelHeader,
    PanelFooter
} from 'components';

import { IState } from 'services/root-reducer';
import {
    getLayerIcon,
    getOperation,
    getLayerObject,
    getOmjsLayerConfig
} from 'selectors';
import { ObjectsHelper } from 'utils';

import {
    actions as objectComparisonActions
} from 'services/objects-comparison/objects-comparison-service';
import { IObjectSignature } from 'types';
import { WithTranslation, withTranslation } from 'react-i18next';
import { ComparisonItem } from './comparison-item';

import './style.scss';
import { ComparisonMenuEmpty } from './comparison-menu-empty';

export interface IObjectsComparisonMenuStoreProps {
    compare_operation: IState['operations']['OBJECTS_COMPARISON'];
}

export interface IObjectsComparisonMenuProps extends IObjectsComparisonMenuStoreProps, WithTranslation {
    open: boolean;
    onOpen: () => any;
    onClose: () => any;
    onCompareClick: () => any;
}
export interface IObjectsComparisonMenuState {}

const mapStateToProps = (state: IState): IObjectsComparisonMenuStoreProps => ({
    compare_operation: getOperation(state, 'OBJECTS_COMPARISON')
});

export const renderComparisonItem = (item: IObjectSignature) => {
    let object = getLayerObject(false, item.layer_code, item.object_id);
    let layer_icon = getLayerIcon(false, {
        layer_code: item.layer_code,
        object_id: item.object_id
    });
    let layer_config = getOmjsLayerConfig(false, item.layer_code);

    return (
        <ComparisonItem
            key={object.id}
            name={ObjectsHelper.getObjectName(object, layer_config as omjs.ILayerConfig)}
            icon={layer_icon}
            onRemoveClick={() => {
                objectComparisonActions.removeItem({
                    layer_code: item.layer_code,
                    object_id: item.object_id
                });
            }}
        />
    );
};

class ObjectsComparisonMenuComponent extends React.Component<IObjectsComparisonMenuProps, IObjectsComparisonMenuState> {
    constructor(props: IObjectsComparisonMenuProps) {
        super(props);
    }

    render() {
        let { open, compare_operation } = this.props;
        let { object_ids } = compare_operation.data;
        let has_objects = !!object_ids.length;
        if (!open) {
            return (
                <Button
                    variant='black'
                    icon={<Icons.IconCompare />}
                    onClick={this.props.onOpen}
                />
            );
        } else {
            return (
                <Panel className="objects-comparison-menu-panel">
                    <PanelHeader className='objects-comparison-menu-panel-header'>
                        <div className="window-title">
                            {this.props.t('Сравнить')}
                        </div>
                        <CloseButton
                            onClick={this.props.onClose}
                        />
                    </PanelHeader>
                    <PanelBody className="objects-comparison-menu-panel-body">
                        {
                            has_objects
                                ? object_ids.map(renderComparisonItem)
                                : <ComparisonMenuEmpty />
                        }
                    </PanelBody>
                    <PanelFooter className='objects-comparison-menu-panel-footer'>
                        {
                            has_objects
                                ? (
                                    <Button
                                        text={this.props.t('Сравнить')}
                                        onClick={this.props.onCompareClick}
                                    />
                                )
                                : null
                        }

                    </PanelFooter>
                </Panel>
            );
        }
    }
}

export const ObjectsComparisonMenu = connect(mapStateToProps)(withTranslation()(ObjectsComparisonMenuComponent));
